<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>

        <div class="row" v-if="!loading">
            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-shopping-cart h2 text-primary align-middle mb-0 mr-3"></i> Ilość zakupionych produktów
                        </p>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center align-items-center">
                                <h3>{{ data.stats.purchasesCount }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-sort-numeric-up-alt h2 text-primary align-middle mb-0 mr-3"></i> Najwięcej punktów u klienta
                        </p>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center align-items-center">
                                <h3>{{ data.stats.maxClientCoins }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted mb-2">
                            <i class="fa fa-user h2 text-primary align-middle mb-0 mr-3"></i> Średnio punktów u klienta
                        </p>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center align-items-center">
                                <h3>{{ data.stats.avgClientCoins }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!loading">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-shopping-cart"></i> Produkty w sklepie
                    </div>
                    <div class="card-body">
                        <data-table
                            :items="data.items"
                            :fields="fields"
                            edit
                            v-on:edit="openEditModal"
                            delete
                            v-on:delete="handleDelete"
                        >
                            <template v-slot:updated_at="row">
                                {{ row.value | moment("DD-MM-YYYY HH:mm") }}
                            </template>
                            <template v-slot:created_at="row">
                                {{ row.value | moment("DD-MM-YYYY HH:mm") }}
                            </template>
                            <template v-slot:client="row">
                                <client :client="row.value" withAvatar/>
                            </template>
                            <template v-slot:type="row">
                                <span>{{ types[row.value] }}</span>
                            </template>
                            <template v-slot:details="row">
                                <div v-if="row.item.type == 0">
                                     Grupy: <server-groups :groups="row.value.groups" withName/>
                                </div>
                            </template>
                            <template v-slot:ignored_server_groups="row">
                                <div v-if="row.value.length">
                                    <server-groups :groups="row.value" withName/>
                                </div>
                                <div v-else>
                                    ---
                                </div>
                            </template>
                        </data-table>
                        <div class="d-flex justify-content-center">
                            <button v-b-modal.modal-add class="btn btn-success">
                                <i class="fa fa-plus"></i> Dodaj nowy przedmiot
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!loading">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-chart-bar"></i> Historia zakupów
                    </div>
                    <div class="card-body">
                        <data-table
                            :items="data.history"
                            :fields="fieldsHistory"
                        >
                            <template v-slot:created_at="row">
                                {{ row.value | moment("DD-MM-YYYY HH:mm") }}
                            </template>
                            <template v-slot:client="row">
                                <client :client="row.value" withAvatar/>
                            </template>
                            <template v-slot:type="row">
                                <span>{{ types[row.value] }}</span>
                            </template>
                            <template v-slot:details="row">
                                <div v-if="row.item.type == 0">
                                    Grupy: <server-groups :groups="row.value.groups" withName/>
                                </div>
                            </template>
                            <template v-slot:active="row">
                                <span v-if="row.value" class="text-success"><i class="fa fa-check"></i> Aktywne</span>
                                <span v-else class="text-danger"><i class="fa fa-times"></i> Nieaktywne</span>
                            </template>
                        </data-table>
                    </div>
                </div>
            </div>
        </div>

        <b-modal
            id="modal-add"
            centered
            title="Dodaj nowy przedmiot"
            title-class="font-18"
            size="lg"
        >
            <div>
                <form class="needs-validation" @submit.prevent="() => {}">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="newItem.name">Nazwa</label>
                                <input
                                    id="newItem.name"
                                    v-model="newItem.name"
                                    :class="{ 'is-invalid': $v.newItem.name.$error }"
                                    class="form-control"
                                    placeholder="Ranga VIP 3msc"
                                    type="text"
                                />
                                <div v-if="$v.newItem.name.$error" class="invalid-feedback">
                                    <span v-if="!$v.newItem.name.required">To pole jest wymagane.</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="newItem.description">Opis</label>
                                <textarea
                                    id="newItem.description"
                                    v-model="newItem.description"
                                    class="form-control"
                                    :class="{ 'is-invalid': $v.newItem.description.$error }"
                                />
                                <div v-if="$v.newItem.description.$error" class="invalid-feedback">
                                    <span v-if="!$v.newItem.description.required">To pole jest wymagane.</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="newItem.type">Typ produktu</label>
                                <select
                                    id="newItem.type"
                                    v-model="newItem.type"
                                    :class="{ 'is-invalid': $v.newItem.type.$error }"
                                    class="form-control"
                                >
                                    <option v-for="(value, key) in types" :key="'a'+key" :value="key">{{ value }}</option>
                                </select>
                                <div v-if="$v.newItem.type.$error" class="invalid-feedback">
                                    <span v-if="!$v.newItem.type.required">To pole jest wymagane.</span>
                                </div>
                            </div>

                            <div v-if="newItem.type == 0">
                                <div class="form-group">
                                    <label for="newItem.details.sgid">Grupa/Grupy</label>
                                    <multiselect
                                        v-model="newItem.details.groups"
                                        id="newItem.details.sgid"
                                        :options="data.serverGroups"
                                        selectLabel="Wybierz"
                                        selectedLabel="Wybrany"
                                        placeholder="Wybierz coś"
                                        deselectLabel="Usuń"
                                        track-by="name"
                                        :closeOnSelect="false"
                                        :multiple="true"
                                    >
                                        <template slot="tag" slot-scope="{ option, remove, index }">
                                        <span class="multiselect__tag" :key="index">
                                            <server-group :group="option" withName/>
                                            <i tabindex="1" @keypress.enter.prevent="remove(option)"  @mousedown.prevent="remove(option)" class="multiselect__tag-icon"></i>
                                        </span>
                                        </template>
                                        <template slot="option" slot-scope="props"><server-group :group="props.option" withName/></template>
                                    </multiselect>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="newItem.duration">Długość trwania (w dniach)</label>
                                <input
                                    id="newItem.duration"
                                    v-model="newItem.duration"
                                    :class="{ 'is-invalid': $v.newItem.duration.$error }"
                                    class="form-control"
                                    type="number"
                                />
                                <div v-if="$v.newItem.duration.$error" class="invalid-feedback">
                                    <span v-if="!$v.newItem.duration.required">To pole jest wymagane.</span>
                                    <span v-if="!$v.newItem.duration.minValue">Minimalna wartość to zero.</span>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="newItem.ignored_server_groups">Grupy, które nie mogą kupić danego przedmiotu</label>
                                <multiselect
                                    v-model="newItem.ignored_server_groups"
                                    id="newItem.ignored_server_groups"
                                    :options="data.serverGroups"
                                    :custom-label="groupName"
                                    track-by="name"
                                    selectLabel="Wybierz"
                                    selectedLabel="Wybrany"
                                    placeholder="Wybierz coś"
                                    deselectLabel="Usuń"
                                    :closeOnSelect="false"
                                    :multiple="true"
                                >
                                    <template slot="tag" slot-scope="{ option, remove, index }">
                                    <span class="multiselect__tag" :key="index">
                                        <server-group :group="option" withName/>
                                        <i tabindex="1" @keypress.enter.prevent="remove(option)"  @mousedown.prevent="remove(option)" class="multiselect__tag-icon"></i>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props"><server-group :group="props.option" withName/></template>
                                </multiselect>
                                <small>Jeśli chcesz, aby każdy użytkownik mógł kupić ten produkt, zostaw to pole puste.</small>
                            </div>

                            <div class="form-group">
                                <label for="newItem.coins">Koszt</label>
                                <input
                                    id="newItem.coins"
                                    v-model="newItem.coins"
                                    :class="{ 'is-invalid': $v.newItem.coins.$error }"
                                    class="form-control"
                                    type="number"
                                />
                                <div v-if="$v.newItem.coins.$error" class="invalid-feedback">
                                    <span v-if="!$v.newItem.coins.required">To pole jest wymagane.</span>
                                    <span v-if="!$v.newItem.coins.minValue">Minimalna wartość to zero.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <b-button
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="handleAdd"
                    >
                        <i class="fa fa-plus"></i> Dodaj produkt
                    </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal
            id="modal-edit"
            centered
            title="Edytujesz produkt"
            title-class="font-18"
            size="lg"
        >
            <div>
                <form class="needs-validation" @submit.prevent="() => {}" v-if="currentItem.name">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="newItem.name">Nazwa</label>
                                <input
                                    id="currentItem.name"
                                    v-model="currentItem.name"
                                    :class="{ 'is-invalid': $v.currentItem.name.$error }"
                                    class="form-control"
                                    placeholder="Ranga VIP 3msc"
                                    type="text"
                                />
                                <div v-if="$v.currentItem.name.$error" class="invalid-feedback">
                                    <span v-if="!$v.currentItem.name.required">To pole jest wymagane.</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="currentItem.description">Opis</label>
                                <textarea
                                    id="currentItem.description"
                                    v-model="currentItem.description"
                                    class="form-control"
                                    :class="{ 'is-invalid': $v.currentItem.description.$error }"
                                />
                                <div v-if="$v.currentItem.description.$error" class="invalid-feedback">
                                    <span v-if="!$v.currentItem.description.required">To pole jest wymagane.</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="currentItem.type">Typ produktu</label>
                                <select
                                    id="currentItem.type"
                                    v-model="currentItem.type"
                                    :class="{ 'is-invalid': $v.currentItem.type.$error }"
                                    class="form-control"
                                >
                                    <option v-for="(value, key) in types" :key="key" :value="key">{{ value }}</option>
                                </select>
                                <div v-if="$v.currentItem.type.$error" class="invalid-feedback">
                                    <span v-if="!$v.currentItem.type.required">To pole jest wymagane.</span>
                                </div>
                            </div>

                            <div v-if="currentItem.type == 0">
                                <div class="form-group">
                                    <label for="currentItem.details.sgid">Grupa/Grupy</label>
                                    <multiselect
                                        v-model="currentItem.details.groups"
                                        id="currentItem.details.sgid"
                                        :options="data.serverGroups"
                                        :custom-label="groupName"
                                        track-by="name"
                                        selectLabel="Wybierz"
                                        selectedLabel="Wybrany"
                                        placeholder="Wybierz coś"
                                        deselectLabel="Usuń"
                                        :closeOnSelect="false"
                                        :multiple="true"
                                    >
                                        <template slot="tag" slot-scope="{ option, remove, index }">
                                        <span class="multiselect__tag" :key="index">
                                            <server-group :group="option" withName/>
                                            <i tabindex="1" @keypress.enter.prevent="remove(option)"  @mousedown.prevent="remove(option)" class="multiselect__tag-icon"></i>
                                        </span>
                                        </template>
                                        <template slot="option" slot-scope="props"><server-group :group="props.option" withName/></template>
                                    </multiselect>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="currentItem.duration">Długość trwania (w dniach)</label>
                                <input
                                    id="currentItem.duration"
                                    v-model="currentItem.duration"
                                    :class="{ 'is-invalid': $v.currentItem.duration.$error }"
                                    class="form-control"
                                    type="number"
                                />
                                <div v-if="$v.currentItem.duration.$error" class="invalid-feedback">
                                    <span v-if="!$v.currentItem.duration.required">To pole jest wymagane.</span>
                                    <span v-if="!$v.currentItem.duration.minValue">Minimalna wartość to zero.</span>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="currentItem.ignored_server_groups">Grupy, które nie mogą kupić danego przedmiotu</label>
                                <multiselect
                                    v-model="currentItem.ignored_server_groups"
                                    id="currentItem.ignored_server_groups"
                                    :options="data.serverGroups"
                                    :custom-label="groupName"
                                    track-by="name"
                                    selectLabel="Wybierz"
                                    selectedLabel="Wybrany"
                                    placeholder="Wybierz coś"
                                    deselectLabel="Usuń"
                                    :closeOnSelect="false"
                                    :multiple="true"
                                >
                                    <template slot="tag" slot-scope="{ option, remove, index }">
                                    <span class="multiselect__tag" :key="index">
                                        <server-group :group="option" withName/>
                                        <i tabindex="1" @keypress.enter.prevent="remove(option)"  @mousedown.prevent="remove(option)" class="multiselect__tag-icon"></i>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props"><server-group :group="props.option" withName/></template>
                                </multiselect>
                                <small>Jeśli chcesz, aby każdy użytkownik mógł kupić ten produkt, zostaw to pole puste.</small>
                            </div>

                            <div class="form-group">
                                <label for="currentItem.coins">Koszt</label>
                                <input
                                    id="currentItem.coins"
                                    v-model="currentItem.coins"
                                    :class="{ 'is-invalid': $v.currentItem.coins.$error }"
                                    class="form-control"
                                    type="number"
                                />
                                <div v-if="$v.currentItem.coins.$error" class="invalid-feedback">
                                    <span v-if="!$v.currentItem.coins.required">To pole jest wymagane.</span>
                                    <span v-if="!$v.currentItem.coins.minValue">Minimalna wartość to zero.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <b-button
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="handleEdit"
                    >
                        <i class="fa fa-save"></i> Zapisz zmiany
                    </b-button>
                </div>
            </template>
        </b-modal>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ManageShopService from "@/services/manage-shop.service";
import {
    notificationMethods
} from "@/state/helpers";
import {minValue, required} from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

/**
 * Starter component
 */
export default {
    name: "ManageShop",
    components: {Layout, PageHeader, Multiselect},
    data() {
        return {
            title: "Zarządzanie sklepem",
            items: [
                {
                    text: "Admin",
                    href: "/"
                },
                {
                    text: "Zarządzanie sklepem",
                    active: true
                }
            ],
            fields: [
                {key: "id", label: "ID"},
                {key: "name", label: "Nazwa"},
                {key: "description", label: "Opis"},
                {key: "type", label: "Typ"},
                {key: "details", label: "Szczegóły"},
                {key: "coins", label: "Cena"},
                {key: "duration", label: "Czas trwania (dni)"},
                {key: "ignored_server_groups", label: "Grupy ignorowane"},
                {key: "client", label: "Autor"},
                {key: "updated_at", label: "Data edycji"},
                {key: "created_at", label: "Data utworzenia"},
            ],
            fieldsHistory: [
                {key: "client", label: "Klient"},
                {key: "active", label: "Status"},
                {key: "name", label: "Nazwa"},
                {key: "type", label: "Typ"},
                {key: "details", label: "Szczegóły"},
                {key: "coins", label: "Cena"},
                {key: "duration", label: "Czas trwania (dni)"},
                {key: "created_at", label: "Data kupna"},
            ],
            loading: false,
            data: {
                items: [],
                history: [],
                stats: {}
            },
            newItem: {
                details: {
                    groups: null
                }
            },
            currentItem: {},
            details: {
                groups: null
            },
            types: {
                0: "Grupa serwerowa"
            }
        };
    },
    validations: {
        newItem: {
            name: {required: required},
            description: {required: required},
            type: {required: required},
            coins: {required: required, minValue: minValue(0)},
            duration: {required: required, minValue: minValue(0)},
            ignored_server_groups: {},
        },
        currentItem: {
            name: {required: required},
            description: {required: required},
            type: {required: required},
            coins: {required: required, minValue: minValue(0)},
            duration: {required: required, minValue: minValue(0)},
            ignored_server_groups: {},
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ... notificationMethods,
        groupName(field) {
            return field.name+' - ('+field.sgid+')';
        },
        loadData() {
            this.currentItem = {};
            this.newItem = {
                details: this.details
            };
            this.loading = true;

            ManageShopService.getData().then(
                response => {
                    this.data = response.data;
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        handleAdd() {
            this.$v.newItem.$touch();

            if (this.$v.newItem.$invalid) {
                return;
            } else {
                this.$bvModal.hide("modal-add");
                this.loading = true;

                ManageShopService.save(this.sanitizeData(this.newItem)).then(
                    () => {
                        this.success("Produkt został dodany");
                        this.$v.newItem.$reset();
                        this.loadData();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        handleDelete(row) {
            this.loading = true;

            ManageShopService.delete(row.id).then(
                () => {
                    this.success("Produkt został usunięty");
                    this.loadData();
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        openEditModal(row) {
            this.currentItem = row;
            this.currentItem.details = {
                ...this.details,
                ...row.details
            };

            this.$bvModal.show("modal-edit");
        },
        handleEdit() {
            this.$v.currentItem.$touch();

            if (this.$v.currentItem.$invalid) {
                return;
            } else {
                this.$bvModal.hide("modal-edit");
                this.loading = true;

                ManageShopService.edit(this.currentItem.id, this.sanitizeData(this.currentItem)).then(
                    () => {
                        this.success("Produkt został zedytowany");
                        this.currentItem = {};
                        this.$v.currentItem.$reset();
                        this.loadData();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        sanitizeData(data) {
            let newData = {};
            const toNum = ['type', 'coins', 'duration'];

            Object.keys(data).forEach(d => {
                if (d == 'details')
                    newData[d] = this.getDetails(data.type, data[d]);
                else if (d == 'ignored_server_groups')
                    newData[d] = this.getIgnoredServerGroups(data[d]);
                else if (toNum.includes(d))
                    newData[d] = Number(data[d]);
                else
                    newData[d] = data[d];
            })
            return newData;
        },
        getDetails(type, details) {
            switch (Number(type)) {
                case 0:
                    var newGroups = [];
                    details.groups.forEach(g => {
                        newGroups.push(g.sgid)
                    });
                    return newGroups;
                default:
                    return null;
            }
        },
        getIgnoredServerGroups(data) {
            let newData = [];

            data.forEach(group => {
                newData.push(group.sgid);
            });

            return newData;
        }
    }
};
</script>